import { financeAuthApi } from '../api'
import { FINANCE_TOKEN_KEY, clearFinanceToken } from '../api/financeRequest'

/** Vuex module: register with the host store as `finance` to avoid replacing legacy state. */
const financeModule = {
  namespaced: true,
  state: {
    user: null,
    unit: null,
    sidebarCollapsed: false,
    currentMonth: new Date().toISOString().slice(0, 7),
  },
  getters: {
    isAuthenticated: () => !!sessionStorage.getItem(FINANCE_TOKEN_KEY),
    userName: (state) => state.user?.name || state.user?.account || '',
  },
  mutations: {
    setSession(state, payload) {
      state.user = payload?.user || payload
      state.unit = payload?.unit || null
    },
    clearSession(state) {
      state.user = null
      state.unit = null
      clearFinanceToken()
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
  },
  actions: {
    async loadSession({ commit }) {
      const user = await financeAuthApi.me()
      commit('setSession', user)
      return user
    },
    logout({ commit }) {
      financeAuthApi.logout().catch(() => {})
      commit('clearSession')
    },
  },
}

export { financeModule }
export default financeModule
